import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../../../../../reducers/types";
import { updateWatch } from "../../../../../../../TripsList/actions/actions";
import {
  getOpenModal,
  getUpdateWatchCallState,
  getWatchContext,
} from "../../../../../../../TripsList/reducer";
import { ChangeEmailModalContent } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  openModal: getOpenModal(state),
  updateWatchCallState: getUpdateWatchCallState(state),
  context: getWatchContext(state),
});

const mapDispatchToProps = {
  updateWatch,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type ChangeEmailModalContentConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedChangeEmailModalContent = connector(
  ChangeEmailModalContent
);
